export const LightspeedLogoURL = "/images/lightspeedlogo.svg";
export const VideoPosterURL = "/images/videoPoster.jpg";
